const withdrawIntentDictIT = {
  paypalEmail: "Inserisci l'e-mail di PayPal qui sotto",
  amountWithdrawn: "Importo prelevato dal portafoglio",
  amountDeposited: "Importo depositato su PayPal",
  withdrawFee: "tassa di prelievo",
  paypalFee: "PayPal applicherà una tassa del",
  onTop: "sul valore trasferito",
  requestWithdraw: "Richiedi il ritiro",
  amountWithdrawnSuccessfully: "Importo prelevato con successo!",
  invalidemail: "e-mail non valido",
  withdrawRequests: "Richieste di prelievo",
  requestDate: "Data richiesta",
  processDate: "Data di elaborazione",
  processing: "In lavorazione",
  amountToDeposit: "Ammontare da depositare",
  amountRequested: "Importo richiesto",
  processRequest: "Processi la richiesta",
  process: "Processi",
  withdrawProcessedSuccessfully: "Richiesta di prelievo elaborata con successo!",
  withdrawWith: "Prelievo con",
  bank: "Banca",
  bankName: "Nome della banca",
  bankAccountNumber: "IBAN",
  accountOwner: "Nome del proprietario del conto bancario",
  allFieldsRequired: "Tutti i campi sono obbligatori",
  previousBankDataFound: "Dati bancari precedenti trovati:",
  previousPaypalEmailsFound: "E-mail PayPal precedenti trovate:",
  clickToUseOrTypeNew: "Clicca per usare o digita una nuova",
  cashbackForBuyer: "Cashback per l'acquirente",
  cashbackToBuyersSponsor: "Cashback per lo sponsor dell'acquirente",
  cashbackToSellersSponsor: "Cashback per lo sponsor del venditore",
  amountToBeReceived: "Importo da ricevere",
  withdrawalRequestsPageTitle: "Richieste di prelievo",
  withdrawalRequestsSubtitle: "Cronologia delle richieste di prelievo effettuate.",
  account: "Conto",
  amountToTransfer: "Importo da trasferire",
  fee: "Commissione",
  noWithdrawalRequests: "Nessuna richiesta di prelievo ancora.",
};

export default withdrawIntentDictIT;
